import isObject from 'lodash/isObject';
import isUndefined from 'lodash/isUndefined';
import $axios from './axios';
export default {
    async post(url, body = {}) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
        const headers = await this.getHeaders();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-return,@typescript-eslint/no-unsafe-assignment
        return await $axios.post(url, body, { headers })
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .then(({ data }) => data)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
            .catch((response) => this.parseError(response));
    },
    async put(url, body) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
        const headers = await this.getHeaders();
        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-return
        return await $axios.put(url, body, headers)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .then(({ data }) => data)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
            .catch((response) => this.parseError(response));
    },
    async get(url, parameters = null) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
        const headers = await this.getHeaders();
        // eslint-disable-next-line @typescript-eslint/restrict-plus-operands,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-assignment,@typescript-eslint/no-unsafe-return
        return await $axios.get(url + this.prepareParameters(parameters), { headers })
            // eslint-disable-next-line @typescript-eslint/no-unsafe-return
            .then(({ data }) => data)
            // eslint-disable-next-line @typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access,@typescript-eslint/no-unsafe-return
            .catch((response) => this.parseError(response));
    },
    async getHeaders(options = {}) {
        let { json } = options;
        if (isUndefined(json))
            json = true;
        return new Promise((resolve => {
            const headers = {};
            if (json) {
                headers['Content-Type'] = 'application/json';
            }
            resolve(headers);
        }));
    },
    parseError(responseObject) {
        if (typeof responseObject === 'object' && responseObject.error) {
            const { error } = responseObject;
            if (error.message) {
                throw Error(error.message);
            }
        }
        else if (typeof responseObject === 'object' && responseObject.response) {
            const { response } = responseObject;
            if (typeof response === 'object' && response.data && response.data.message) {
                throw Error(responseObject.response.data.message);
            }
        }
        throw Error('Chyba požadavku');
    },
    /**
     * @param {Object} parameters
     * @return {string}
     */
    prepareParameters(parameters = {}) {
        let result = '';
        if (false === isObject(parameters))
            parameters = {};
        if (Object.keys(parameters).length) {
            const buffer = [];
            for (const key in parameters) {
                // eslint-disable-next-line no-prototype-builtins
                if (parameters.hasOwnProperty(key)) {
                    if (typeof parameters[key] === 'object') {
                        for (const subKey in parameters[key]) {
                            // eslint-disable-next-line no-prototype-builtins,@typescript-eslint/no-unsafe-call,@typescript-eslint/no-unsafe-member-access
                            if (parameters[key].hasOwnProperty(subKey)) {
                                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument,@typescript-eslint/no-unsafe-member-access
                                buffer.push(key + '=' + encodeURIComponent(parameters[key][subKey]));
                            }
                        }
                    }
                    else {
                        // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                        buffer.push(key + '=' + encodeURIComponent(parameters[key]));
                    }
                }
            }
            result = '?' + buffer.join('&');
        }
        return result;
    }
};
